
import { computed, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useDisplayName, useProfile } from '../../composables'
export default defineComponent({
  name: 'ProfilePage',
  props: {
    editing: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const profile = useProfile()
    const displayName = useDisplayName(profile)
    const router = useRouter()
    const properties = computed(() => profile.value?.collection.properties)

    const store = useStore()
    const form = computed(() => store.getters['rxdb/form'])
    const read = () =>
      profile.value &&
      router.replace({
        name: 'profile'
      })

    const edit = () =>
      profile.value &&
      router.replace({
        name: 'profile',
        params: {
          action: 'edit'
        }
      })
    const save = async () => {
      await store.dispatch('rxdb/save')
      read()
    }
    const reset = () => {
      store.commit('rxdb/reset')
    }
    const cancel = () => {
      reset()
      read()
    }

    return {
      profile,
      form,
      properties,
      save,
      reset,
      cancel,
      edit,
      displayName
    }
  }
})
